import { NavLink, Outlet, useParams } from 'react-router-dom';
import { Layout, Typography } from 'antd';
import {
  BarChartOutlined, BankOutlined, DollarOutlined, FileTextOutlined, ProfileOutlined, RollbackOutlined,
  WalletOutlined, ExclamationCircleOutlined,
} from '@ant-design/icons';

/**
 * Accounts desk — the fee counter's surface. Two tabs: Counter (open invoices +
 * record payment) and Receipts (today's + search).
 */
export function AccountsDeskShell() {
  const { institution = '' } = useParams<{ institution: string }>();
  return (
    <Layout style={{ minHeight: 'calc(100vh - 50px)', background: '#f7f7f5' }}>
      <Layout.Content style={{ padding: '18px 18px 74px', maxWidth: 1000, margin: '0 auto', width: '100%' }}>
        <div style={{ marginBottom: 12 }}>
          <Typography.Text type="secondary" style={{ fontSize: 11, letterSpacing: 0.4, textTransform: 'uppercase', fontWeight: 600 }}>
            Accounts desk
          </Typography.Text>
        </div>
        <Outlet />
      </Layout.Content>
      <nav
        style={{
          position: 'fixed', bottom: 0, left: 0, right: 0,
          display: 'flex', justifyContent: 'space-around',
          background: '#fff', borderTop: '1px solid #e6e6e9',
          padding: '8px 0', zIndex: 100,
        }}
      >
        <TabItem to={`/i/${institution}/accounts`} end icon={<DollarOutlined />} label="Counter" />
        <TabItem to={`/i/${institution}/accounts/receipts`} icon={<FileTextOutlined />} label="Receipts" />
        <TabItem to={`/i/${institution}/accounts/defaulters`} icon={<ExclamationCircleOutlined />} label="Defaulters" />
        <TabItem to={`/i/${institution}/accounts/bills`} icon={<ProfileOutlined />} label="Bills" />
        <TabItem to={`/i/${institution}/accounts/petty-cash`} icon={<WalletOutlined />} label="Petty" />
        <TabItem to={`/i/${institution}/accounts/reconciliation`} icon={<BankOutlined />} label="Recon" />
        <TabItem to={`/i/${institution}/accounts/refunds`} icon={<RollbackOutlined />} label="Refunds" />
        <TabItem to={`/i/${institution}/accounts/reports`} icon={<BarChartOutlined />} label="Reports" />
      </nav>
    </Layout>
  );
}

function TabItem({ to, icon, label, end }: { to: string; icon: React.ReactNode; label: string; end?: boolean }) {
  return (
    <NavLink
      to={to}
      end={end}
      style={({ isActive }) => ({
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        gap: 2, textDecoration: 'none',
        color: isActive ? '#2f6ab0' : '#5b6478',
        fontSize: 11, fontWeight: isActive ? 600 : 500,
      })}
    >
      <span style={{ fontSize: 20 }}>{icon}</span>
      {label}
    </NavLink>
  );
}
